import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { CheckCircle2 } from 'lucide-react'

function About() {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-8">About Hill Bros</h1>
        
        <Card className="max-w-4xl mx-auto mb-8">
          <CardHeader>
            <CardTitle>Over 45 Years of Excellence</CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            <p className="text-lg mb-4">
              We are a proud, family-run roofing and building company that has been helping to 
              rebuild and restore Brighton & Hove for over 45 years. Our reputation is built on 
              trust, quality workmanship, and a commitment to delivering exceptional results on 
              every project we undertake.
            </p>
            
            <p className="mb-4">
              Our highly skilled tradesmen specialise in all aspects of roofing, flat roofing, 
              guttering and fascia installation, leadwork, re-pointing, lime pointing, damp proofing, 
              plastering, and general building. We also provide expert decorating services, drone 
              roof surveys, safe chimney demolition, and sash window repairs.
            </p>

            <p className="mb-4">
              With decades of hands-on experience, we combine traditional craftsmanship with modern 
              techniques to ensure every job is completed to the highest standard. Whether we're 
              restoring a historic property, carrying out a full roof renewal, or performing essential 
              maintenance, we approach every project with care, attention to detail, and a genuine 
              passion for preserving Brighton's unique character.
            </p>

            <p className="mb-4">
              We pride ourselves on being reliable, approachable, and easy to work with—many of our 
              clients come to us through recommendations and repeat business. When you choose us, 
              you can trust that your property is in expert hands.
            </p>
          </CardContent>
        </Card>

        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle>Our Values</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5" />
                <span>Quality workmanship on every project</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5" />
                <span>Honest, transparent pricing</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5" />
                <span>Reliable and punctual service</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5" />
                <span>Respect for your property</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5" />
                <span>Clear communication throughout</span>
              </li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default About